import React from 'react';
import {
  Show,
  ShowProps,
  SimpleShowLayout,
  useShowController,
} from 'react-admin';
import { Divider } from '@material-ui/core';
import ImmunotherapyAnswers from '../../../../components/ImmunotherapyAnswers';
import UserDataBlock from '../../../../components/UserDataBlock';
import ImmunotherapyForm from '../../../../components/ImmonotherapyForm';
import ImmunotherapyTreatmentPreparatoryCallForm from '../../../../components/ImmunotherapyTreatmentPreparatoryCallForm';
import FirstTimeIntakeForm from '../../../../components/FirstTimeIntakeForm';
import OnboardingCheckInForm from '../../../../components/OnboardingCheckInForm';

import {
  TREATMENT_STEP_ORDER,
  TreatmentStepId,
  TREATMENT_STEPS,
} from '../../../../constants/treatmentSteps';

import '../styles.scss';

const ImmunotherapyTreatment = (props: ShowProps) => {
  const { record } = useShowController(props);
  const activeStepId = record?.activeStepId;

  // Find the index of the current active step
  const activeStepIndex = activeStepId
    ? TREATMENT_STEP_ORDER.indexOf(activeStepId as TreatmentStepId)
    : -1;

  // Helper function to check if a step should be shown
  const shouldShowStep = (stepId: TreatmentStepId): boolean => {
    if (activeStepIndex === -1) return false;
    const stepIndex = TREATMENT_STEP_ORDER.indexOf(stepId as TreatmentStepId);
    return stepIndex !== -1 && stepIndex <= activeStepIndex;
  };

  // Helper function to check if a step is readonly
  const isStepReadonly = (stepId: string): boolean => activeStepId !== stepId;

  return (
    <Show {...props} className="treatments-show">
      <SimpleShowLayout>
        <UserDataBlock record={record} />
        <Divider className="divider" />
        <ImmunotherapyAnswers />
        <Divider className="divider" />
        <ImmunotherapyForm data={record?.test} readonly />

        {shouldShowStep(TREATMENT_STEPS.BOOK_PREPARATORY_CONSULTATION) && (
          <ImmunotherapyTreatmentPreparatoryCallForm
            readonly={isStepReadonly(
              TREATMENT_STEPS.BOOK_PREPARATORY_CONSULTATION,
            )}
            data={record}
          />
        )}

        {shouldShowStep(
          TREATMENT_STEPS.BOOK_FIRST_TIME_INTAKE_MEDICATION_ONE,
        ) && (
          <FirstTimeIntakeForm
            readonly={isStepReadonly(
              TREATMENT_STEPS.BOOK_FIRST_TIME_INTAKE_MEDICATION_ONE,
            )}
            data={record}
            stepId={TREATMENT_STEPS.BOOK_FIRST_TIME_INTAKE_MEDICATION_ONE}
          />
        )}

        {shouldShowStep(TREATMENT_STEPS.CHECK_IN_MEDICATION_ONE) && (
          <OnboardingCheckInForm
            readonly={isStepReadonly(TREATMENT_STEPS.CHECK_IN_MEDICATION_ONE)}
            data={record}
            stepId={TREATMENT_STEPS.CHECK_IN_MEDICATION_ONE}
          />
        )}

        {shouldShowStep(
          TREATMENT_STEPS.BOOK_FIRST_TIME_INTAKE_MEDICATION_TWO,
        ) && (
          <FirstTimeIntakeForm
            readonly={isStepReadonly(
              TREATMENT_STEPS.BOOK_FIRST_TIME_INTAKE_MEDICATION_TWO,
            )}
            data={record}
            stepId={TREATMENT_STEPS.BOOK_FIRST_TIME_INTAKE_MEDICATION_TWO}
          />
        )}

        {shouldShowStep(TREATMENT_STEPS.CHECK_IN_MEDICATION_TWO) && (
          <OnboardingCheckInForm
            readonly={isStepReadonly(TREATMENT_STEPS.CHECK_IN_MEDICATION_TWO)}
            data={record}
            stepId={TREATMENT_STEPS.CHECK_IN_MEDICATION_TWO}
          />
        )}
      </SimpleShowLayout>
    </Show>
  );
};

export default ImmunotherapyTreatment;
